import { routes } from "src/shared/routes";
import {
  FAQS,
  FooterLinks,
  REGISTRATION_CARDS,
  NavSubmenuLinks,
  TERMS_AND_CONDITION,
  TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
  AnalyticsHeader,
} from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const BannerImage =
  "https://ss-leagues.s3.amazonaws.com/MLB/Rockies%20Ballpark%20Assets/stadium-ballpark-pass-header-2-1920x1080.jpg";

export const coloradorockies_upgrades: TTeamConfig = {
  TEAM_SCHEMA: "coloradorockies_upgrades",
  TEAM_FULL_NAME: "Colorado Rockies",
  BROWSER_TITLE: "Rockies Upgrades",
  CLIENT_ID: "2aa19bec0e80.seasonshare.corockies-corockies.us",

  TEAM_GLOBAL_SETTINGS: {
    ANALYTICS_HEADER: AnalyticsHeader,
    COLORS_PRIMARY: "#333366",
    COLORS_SECONDARY: "#000000",
    LOGOUT_ON_INVALID_SESSION: false,
    IS_INTERCOM_ENABLED: true,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_UPCOMING_EVENTS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },

    FOOTER: {
      LINKS: FooterLinks,
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()} MLB Advanced Media, L.P. All rights reserved`,
    },

    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/corockies/",
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },

    HIDE_PASSES: true,
    PASS_BANNER: {
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
    SHOW_ALL_PASSES_UNDER_BANNER: true,

    STATIC_BANNER: {
      IS_ENABLED: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: false,
    },

    ADD_ON: {
      ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
        TITLE: () => "Purchase Confirmed!",
        DESCRIPTION: () =>
          "Thank you for your purchase, your tickets are now available. Login to your Ballpark app to view your barcodes.",
      },

      ADD_SERVICE_FEE_TO_PRICE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  IMAGES: {
    ORDER_SUMMERY_BACKGROUND_URL: BannerImage,
    LANDING_PAGE_STATIC_BANNER_URL: BannerImage,
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/COL-2.png",
    FOOTER_LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/COL-2.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
  },
};
